module.exports = __webpack_public_path__ + "media/images/portugal_center/Circuito_Coimbra-41318dcb6eef23769dc9a640cf166c62.jpg";